import moment from 'jalali-moment';
import { ToEnglishDigits } from './string-tool';
// declare global {
// 	interface DateConstructor {
// 		today: () => Date;
// 		ticksToDate: (value: string) => Date;
// 	}
// }
// Date.ticksToDate = function (value: string): Date {
// 	if (!value) return null;
// 	const ticksToMicrotime = +value / 10000;
// 	const epochMicrotimeDiff = Math.abs(new Date(0, 0, 1).setFullYear(1));
// 	return new Date(ticksToMicrotime - epochMicrotimeDiff);
// };

export class DateHelper {
	static ticksToDate(value: string): Date {
		if (!value) return null;
		const ticksToMicrotime = +value / 10000;
		const epochMicrotimeDiff = Math.abs(new Date(0, 0, 1).setFullYear(1));
		return new Date(ticksToMicrotime - epochMicrotimeDiff);
	}
	static getPersianMonth(value: Date | string): string {
		const MomentDate = moment(new Date(value));
		const jdate = MomentDate.locale('fa').format('YYYY/M/D');
		let month = '';
		switch (parseInt(jdate.substr(5, 2).replace('/', ''))) {
			case 1:
				month = 'فروردین';
				break;
			case 2:
				month = 'اردیبهشت';
				break;
			case 3:
				month = 'خرداد';
				break;
			case 4:
				month = 'تیر';
				break;
			case 5:
				month = 'مرداد';
				break;
			case 6:
				month = 'شهریور';
				break;
			case 7:
				month = 'مهر';
				break;
			case 8:
				month = 'آبان';
				break;
			case 9:
				month = 'آذر';
				break;
			case 10:
				month = 'دی';
				break;
			case 11:
				month = 'بهمن';
				break;
			case 12:
				month = 'اسفند';
				break;
		}
		return month;
	}
	static getPersianDayOfWeek(value: Date | string): string {
		const daysOfWeek = ['یکشنبه', 'دوشنبه', 'سه شنبه', 'چهارشنبه', 'پنج شنبه', 'جمعه', 'شنبه'];
		return daysOfWeek[new Date(value).getDay()];
	}
	static getJDayOfMonth(value: Date | string): string {
		const MomentDate = moment(new Date(value));
		const jdate = MomentDate.locale('fa').format('YYYY/M/D');
		return jdate.substring(jdate.lastIndexOf('/') + 1);
	}
	static getJDateLongWithDay(value: Date | string): string {
		const daysOfWeek = ['یکشنبه', 'دوشنبه', 'سه شنبه', 'چهارشنبه', 'پنج شنبه', 'جمعه', 'شنبه'];
		let dayOfWeek = daysOfWeek[new Date(value).getDay()];
		const MomentDate = moment(new Date(value));
		const jdate = MomentDate.locale('fa').format('YYYY/M/D');
		let month = '';
		switch (parseInt(jdate.substr(5, 2).replace('/', ''))) {
			case 1:
				month = 'فروردین';
				break;
			case 2:
				month = 'اردیبهشت';
				break;
			case 3:
				month = 'خرداد';
				break;
			case 4:
				month = 'تیر';
				break;
			case 5:
				month = 'مرداد';
				break;
			case 6:
				month = 'شهریور';
				break;
			case 7:
				month = 'مهر';
				break;
			case 8:
				month = 'آبان';
				break;
			case 9:
				month = 'آذر';
				break;
			case 10:
				month = 'دی';
				break;
			case 11:
				month = 'بهمن';
				break;
			case 12:
				month = 'اسفند';
				break;
		}
		const tomorrow = new Date();
		tomorrow.setDate(tomorrow.getDate() + 1);
		tomorrow.setHours(0, 0, 0, 0);

		const today = new Date();
		today.setDate(today.getDate());
		today.setHours(0, 0, 0, 0);
		const now = new Date(value).setHours(0, 0, 0, 0);
		if (now.valueOf() === tomorrow.valueOf()) dayOfWeek = 'فردا';
		if (now.valueOf() === today.valueOf()) dayOfWeek = 'امروز';
		return dayOfWeek + ' - ' + jdate.substring(jdate.lastIndexOf('/') + 1) + ' ' + month;
	}
	static getJDateLongString(value: Date): string {
		const result = DateHelper.getJDateLongWithDay(value);
		const MomentDate = moment(new Date(value));
		const jdate = MomentDate.locale('fa').format('YYYY/M/D');
		return result + ' ' + jdate.substr(0, 4);
	}
	static getJDayOfWeek = (value: number): string => {
		if (value < 0 || value > 6) return '';
		const daysOfWeek = ['یکشنبه', 'دوشنبه', 'سه شنبه', 'چهارشنبه', 'پنج شنبه', 'جمعه', 'شنبه'];
		return daysOfWeek[value];
	};

	static isCurrentDateInDateRange = (
		startDate: string,
		endDate: string,
		startHour: number,
		startMinute: number,
		endHour: number,
		endMinute: number
	) => {
		const sDateTime = moment.from(startDate, 'fa', 'YYYY/M/D').toDate();
		sDateTime.setHours(startHour, startMinute, 0, 0);
		const eDateTime = moment.from(endDate, 'fa', 'YYYY/M/D').toDate();
		eDateTime.setHours(endHour, endMinute, 0, 0);

		const currentDate = new Date();

		return sDateTime <= currentDate && eDateTime >= currentDate;
	};
	static isCurrentTimeInTimeRange = (
		jDate: string,
		endDate: string,
		startHour: number,
		startMinute: number,
		endHour: number,
		endMinute: number
	): boolean => {
		const startTime = moment.from(jDate, 'fa', 'YYYY/M/D').toDate();
		const endTime = moment.from(jDate, 'fa', 'YYYY/M/D').toDate();
		const currentDate = new Date();
		if (!endDate) {
			startTime.setHours(startHour, startMinute, 0, 0);
			endTime.setHours(endHour, endMinute, 59, 59);
			if (startTime <= currentDate && endTime >= currentDate) return true;
			return false;
		}
		const eDate = moment.from(endDate, 'fa', 'YYYY/M/D').toDate();
		startTime.setHours(startHour, startMinute, 0, 0);
		eDate.setHours(endHour, endMinute, 59, 59);
		if (startTime > currentDate || eDate < currentDate) return false;
		const todayValidBegin = new Date();
		todayValidBegin.setHours(startHour, startMinute, 0, 0);

		const todayValidEnd = new Date();
		todayValidEnd.setHours(endHour, endMinute, 59, 59);
		if (todayValidBegin <= currentDate && todayValidEnd >= currentDate) return true;
		return false;
	};
	static convertFormattedNumberToLocaleDate = (value: string): string =>
		new Date(value.replace(/^(\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)$/, '$4:$5:$6 $2/$3/$1')).toLocaleString();

	static getJDate = (value: Date): string => {
		if (value && DateHelper.isValidDate(value)) {
			const MomentDate = moment(value);
			const jdate = MomentDate.locale('fa').format('YYYY/M/D');
			return jdate;
		}
		return '';
	};
	static getDateWithTimeFromNumber = (value: string, hasTime = true): Date => {
		if (value) {
			// var date = new Date(value.replace(
			//   /^(\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)$/,
			//   '$4:$5:$6 $2/$3/$1'
			// ));
			const year = +value.slice(0, 4);
			const month = +value.slice(4, 6);
			const day = +value.slice(6, 8);

			const hours = hasTime ? value.slice(8, 10) : '0';
			const minutes = hasTime ? value.slice(10, 12) : '0';
			const seconds = hasTime ? value.slice(12, 14) : '0';
			const date = new Date(`${year}/${month}/${day} ${hours}:${minutes}:${seconds}`);
			return date;
		}
		return null;
	};

	static getJDateWithTimeFromNumber = (value: string): string => {
		if (value) {
			const year = +value.slice(0, 4);
			const month = +value.slice(4, 6);
			const day = +value.slice(6, 8);
			const hours = value.slice(8, 10);
			const minutes = value.slice(10, 12);
			const seconds = value.slice(12, 14);
			const date = new Date();
			date.setUTCFullYear(year, month - 1, day);
			return DateHelper.getJDate(date) + '  ' + hours + ':' + minutes + ':' + seconds;
		}
		return null;
	};

	static getJDateWithTimeFromNumberSetTimeZone = (value: string, timeOnly?: boolean): string => {
		if (value) {
			const offset = -new Date().getTimezoneOffset();
			// const hoursDiff = Math.floor(offset / 60);
			// const minsDiff = offset % 60;
			const year = +value.slice(0, 4);
			const month = +value.slice(4, 6);
			const day = +value.slice(6, 8);
			const hours = value.slice(8, 10);
			const minutes = value.slice(10, 12);
			const seconds = value.slice(12, 14);
			const date = new Date();
			date.setUTCFullYear(year, month - 1, day);
			date.setHours(+hours);
			date.setMinutes(+minutes);
			date.setSeconds(+seconds);
			const newDateObj = moment(date).add(offset, 'm').toDate();
			return (
				(!timeOnly ? DateHelper.getJDate(newDateObj) + '  ' : '') +
				('0' + newDateObj.getHours()).slice(-2) +
				':' +
				('0' + newDateObj.getMinutes()).slice(-2) +
				':' +
				('0' + newDateObj.getSeconds()).slice(-2)
			);
		}
		return null;
	};

	static getTimeFromNumber = (value: string): string => {
		if (value) {
			const hours = value.slice(8, 10);
			const minutes = value.slice(10, 12);
			const seconds = value.slice(12, 14);
			return hours + ':' + minutes + ':' + seconds;
		}
		return null;
	};

	static getFormattedJDate = (value: Date): string => {
		if (value && DateHelper.isValidDate(value)) {
			const MomentDate = moment(value);
			const jdate = MomentDate.locale('fa').format('YYYY/MM/DD');
			return jdate;
		}
		return null;
	};

	static getFormattedJTime = (value: Date): string => {
		if (value && DateHelper.isValidDate(value)) {
			const MomentDate = moment(value);
			const jTime = MomentDate.locale('fa').format('HH:mm:ss');
			return jTime;
		}
		return null;
	};

	static getFormattedJDateTime = (value: Date): string => {
		if (value && DateHelper.isValidDate(value)) {
			const MomentDate = moment(value);
			const jTime = MomentDate.locale('fa').format('HH:mm:ss YYYY/MM/DD');
			return jTime;
		}
		return null;
	};

	static jDateToDate = (value: string): Date => {
		if (value) {
			value = ToEnglishDigits(value);
			const datestring = moment.from(value, 'fa', 'YYYY/MM/D').locale('en').format('YYYY-MM-DD');
			return new Date(datestring);
		}
		return null;
	};

	static getFormattedDate = (enDate: Date): string => {
		const y = enDate.getFullYear().toString();
		let m = (enDate.getMonth() + 1).toString();
		let d = enDate.getDate().toString();
		if (d.length === 1) d = '0' + d;
		if (m.length === 1) m = '0' + m;
		const yyyymmdd = y + '-' + m + '-' + d;
		return yyyymmdd;
	};

	static gregorianToJalali = (year: number, month: number, day: number) => {
		const g_days = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
		const j_days = [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29];
		const daysOfWeek = ['یک شنبه', 'دو شنبه', 'سه شنبه', 'چهار شنبه', 'پنج شنبه', 'جمعه', 'شنبه'];
		let i: number;
		let t: number;
		let c: number;
		let f: number;
		const r = year - 1600;
		const h = month - 1;
		const y = day - 1;
		let u = 365 * r + Math.floor((r + 3) / 4) - Math.floor((r + 99) / 100) + Math.floor((r + 399) / 400);
		for (i = 0; i < h; ++i) u += g_days[i];
		for (
			h > 1 && ((r % 4 === 0 && r % 100 !== 0) || r % 400 === 0) && ++u,
				u += y,
				t = u - 79,
				c = Math.floor(t / 12053),
				t %= 12053,
				f = 979 + 33 * c + 4 * Math.floor(t / 1461),
				t %= 1461,
				t >= 366 && ((f += Math.floor((t - 1) / 365)), (t = (t - 1) % 365)),
				i = 0;
			i < 11 && t >= j_days[i];
			++i
		)
			t -= j_days[i];
		const date = new Date(year, month - 1, day);
		const dayOfWeek = daysOfWeek[date.getDay()];
		return `${dayOfWeek}  ${f}/${i + 1}/${t + 1}`;
	};

	static utcToTehran = (timeStamp: number, localOffset: number): number => {
		const tehranOffset = 3.5;
		const rawUtc = timeStamp + localOffset;
		const tehranResult = rawUtc + 3600000 * tehranOffset;
		return tehranResult;
	};

	static persianDateToGoDate = (persianDate: string) => {
		if (!persianDate) return persianDate;
		return new Date(
			moment.from(persianDate, 'fa', 'YYYY/M/D').toDate().getTime() -
				moment.from(persianDate, 'fa', 'YYYY/M/D').toDate().getTimezoneOffset() * 60000
		).toISOString();
	};

	static daysBetweenTwoDates = (startDate: Date, endDate: Date) => {
		endDate.setHours(0);
		endDate.setMinutes(0);
		endDate.setSeconds(0);
		startDate.setHours(0);
		startDate.setMinutes(0);
		startDate.setSeconds(0);

		return Math.ceil((+endDate.setHours(0) - +startDate) / (1000 * 60 * 60 * 24));
	};
	static georgianDateToShamsi = (date: Date) =>
		Intl.DateTimeFormat('fa-IR', {
			year: 'numeric',
			month: 'numeric',
			day: 'numeric',
			weekday: 'short'
		}).format(date);

	static isValidDate(d: Date | string) {
		const date = new Date(d);
		return date.getFullYear() > 1800;
	}

	static getDifferTimestampInSeconds = timestamp => {
		const startDate = timestamp;
		const endDate = new Date();
		return (endDate.getTime() - startDate) / 1000;
	};

	/**
	 * @description
	 * get formatted time in this format from timer in hh:mm:ss
	 * @example
	 * getformatTime(300) ==> 05:00
	 * @param time is seconds
	 */
	static getformatTime(time: number): string {
		const pad = (num: number, size: number): string => {
			return ('000' + num).slice(-size);
		};
		const hours: number = Math.floor(time / 3600);
		const minutes: number = Math.floor((time % 3600) / 60);
		const seconds: number = time % 60;
		return `${hours ? pad(hours, 2) + ':' : ''}${pad(minutes, 2)}:${pad(seconds, 2)}`;
	}
}
